import PartnerGroup from '../../../elements/PartnerGroup'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import { defaultFormItemLayout, rules } from '../../../modules/FormItems'
import React from 'react'
import { dateVal, strVal } from '../../../modules/Utils'
import { compose } from 'recompose'
import { Button, Checkbox, Col, DatePicker, Form, Input, Row } from 'antd'
import StatusSelect from '../../../elements/Select/Client/Status'
import CountrySelect from '../../../elements/Select/Country'

function ClientDetailsForm(props) {
  const { submitting, client, update } = props
  const { getFieldDecorator, setFieldsValue, getFieldValue } = props.form
  return (
    <Form>
      <FormSectionTitle title={'Details'} />
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Status">
            {getFieldDecorator('status', {
              initialValue: strVal(client, 'status'),
              rules: rules.input,
            })(<StatusSelect />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Location">
            {getFieldDecorator('location', {
              initialValue: strVal(client, 'location'),
            })(<CountrySelect />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Registration Date">
            <DatePicker
              disabled
              style={{ width: '100%' }}
              placeholder="Registration Date"
              value={dateVal(client, 'date.registration')}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Tax Registration">
            {getFieldDecorator('taxRegistration', {
              initialValue: strVal(client, 'taxRegistration'),
            })(<Input style={{ width: '100%' }} placeholder="Tax Registration" />)}
          </Form.Item>
        </Col>
      </Row>

      <PartnerGroup {...{ data: client, getFieldDecorator, setFieldsValue, getFieldValue }} />

      <Button loading={submitting} type="primary" onClick={update} style={{ marginTop: 20 }}>
        Update
      </Button>
    </Form>
  )
}

export default compose(Form.create())(ClientDetailsForm)
